// extracted by mini-css-extract-plugin
export default {"feedsContainer":"rKeMaaS3mrwsxM6ormd5","responsiveContainer":"AS9_lPrMw5gd43K62QPM"};